// Header Info
export const GET_HEADER_INFO = 'GET_HEADER_INFO';